function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.5,
  fill: "#FCB154",
  stroke: "#E6A462"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 8,
  r: 1,
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 8,
  r: 1,
  fill: "#000"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 12c1.333 1.51 4.8 3.622 8 0",
  stroke: "#000",
  strokeLinecap: "round"
});
function SvgEmojiGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default SvgEmojiGood;